<json-editor  [options]="editorOptions" [data]="data"></json-editor>